var $8e1ed6a70b6e99d0$exports = {};
$8e1ed6a70b6e99d0$exports = {
    "Empty": `T\xfchjenda`
};


export {$8e1ed6a70b6e99d0$exports as default};
//# sourceMappingURL=et-EE.mjs.map
